import React from 'react';
import cn from 'classnames';
import { Form, Layout, Core } from 'connex-cds';
import styled from 'styled-components';
import { useCompanySetup } from '../../../MasterDataProvider';
import Comments from '../../../ticket-details/comments/Comments';
import Attachments from '../../../ticket-details/attchments/Attachments';
import DriverInstructions from '../../../ticket-details/driver-instructions/DriverInstructions';
import DriverCommentInternal from '../../../ticket-details/driver-comment-internal/DriverCommentInternal';
import { LoadingUnloadingPoints } from '../../../ticket-details/logistical-info/loading-unloading-points/LoadingUnloadingPoints';
import { MaterialSummary } from '../../../ticket-details/logistical-info/material-summary/MaterialSummary';
import StatusTimes from '../../../ticket-details/logistical-info/StatusTimes';
import UnloadingMethodForm from '../../../UnloadingMethodForm';
import { TicketDetailActions } from './TicketDetailActions';

const Styled = styled.div`
  & > * {
    &:not(:first-child) {
      margin-top: 10px;
    }
  }
`;

export const TicketDetailMobile = ({
  activeFormsAndWaivers,
  isLoading,
  attachments = [],
  toggleEarlyAcceptance,
  unloadingMethodEnabled,
}) => {
  const companySetup = useCompanySetup();
  const { values } = Form.useFormContext();

  return (
    <Styled className={cn('ticket-detail-mobile')}>
      <Core.Spinner spin={isLoading}>
        <MaterialSummary />
        <LoadingUnloadingPoints data={values} />
        {companySetup?.data?.isDriverCommentEnabled && (
          <Layout.Container style={{ padding: '15px' }}>
            <Comments />
          </Layout.Container>
        )}
        {unloadingMethodEnabled && (
          <Layout.Container style={{ padding: '10px', paddingBottom: '5px' }}>
            <UnloadingMethodForm />
          </Layout.Container>
        )}
        <Layout.Container style={{ padding: '10px', flex: '1' }}>
          <DriverInstructions data={values} />
          <TicketDetailActions
            activeFormsAndWaivers={activeFormsAndWaivers}
            toggleEarlyAcceptance={toggleEarlyAcceptance}
          />
        </Layout.Container>
        {companySetup?.data?.isDriverCommentEnabled && (
          <Layout.Container style={{ padding: '15px' }}>
            <DriverCommentInternal />
          </Layout.Container>
        )}
        {attachments?.length > 0 && <Attachments />}
        <StatusTimes />
      </Core.Spinner>
    </Styled>
  );
};
